export const PREFIX_DEFAULT = "obg";
export const PREFIX_LANGUAGE = "language";
export const PREFIX_VERSION = "version";
export const INDEXDB_KEYS_KEY = "indexeddb-keys";
